import { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartCtx = createContext(null);
const LS_CART = "fta_cart_v1";
const LS_DISCOUNT = "fta_discount_v1";
const API = process.env.REACT_APP_BACKEND_URL;

export function CartProvider({ children }) {
  const [lines, setLines] = useState(() => {
    try { return JSON.parse(localStorage.getItem(LS_CART) || "[]"); } catch { return []; }
  });
  const [discountToken, setDiscountToken] = useState(() => localStorage.getItem(LS_DISCOUNT) || null);
  const [totals, setTotals] = useState({ subtotal: 0, discount_amount: 0, discount_valid: false, total: 0, lines: [] });
  const [showToast, setShowToast] = useState(null);

  useEffect(() => { localStorage.setItem(LS_CART, JSON.stringify(lines)); }, [lines]);
  useEffect(() => {
    if (discountToken) localStorage.setItem(LS_DISCOUNT, discountToken);
    else localStorage.removeItem(LS_DISCOUNT);
  }, [discountToken]);

  // Server-side pricing on every change
  useEffect(() => {
    if (!lines.length) { setTotals({ subtotal:0, discount_amount:0, discount_valid:false, total:0, lines:[] }); return; }
    fetch(`${API}/api/cart/validate`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ lines, discount_token: discountToken }),
    }).then(r => r.json()).then(setTotals).catch(() => {});
  }, [lines, discountToken]);

  const add = useCallback((slug, size, quantity = 1, meta = {}) => {
    setLines(prev => {
      const i = prev.findIndex(l => l.slug === slug && l.size === size);
      if (i >= 0) { const n = [...prev]; n[i] = { ...n[i], quantity: n[i].quantity + quantity }; return n; }
      return [...prev, { slug, size, quantity }];
    });
    setShowToast({ slug, ...meta });
    setTimeout(() => setShowToast(null), 8000);
  }, []);
  const update = useCallback((slug, size, quantity) => {
    setLines(prev => prev.map(l => l.slug === slug && l.size === size ? { ...l, quantity: Math.max(1, quantity) } : l));
  }, []);
  const remove = useCallback((slug, size) => setLines(prev => prev.filter(l => !(l.slug === slug && l.size === size))), []);
  const clear = useCallback(() => setLines([]), []);
  const count = lines.reduce((s, l) => s + l.quantity, 0);

  return (
    <CartCtx.Provider value={{ lines, totals, count, add, update, remove, clear, discountToken, setDiscountToken, showToast, setShowToast }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
